module.exports = __webpack_public_path__ + "static/media/CTF.1f0db7b3.svg";